import * as emitter from "./emitter";
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var entries = new WeakMap();
function getEntry(target, key) {
    var targetMap = entries.get(target);
    if (!targetMap) {
        targetMap = new Map();
        entries.set(target, targetMap);
    }
    var entry = targetMap.get(key);
    if (!entry) {
        entry = {
            target: target,
            key: key,
            value: undefined,
            contexts: undefined,
            deps: undefined,
            state: 0,
            checksum: 0,
            observed: false
        };
        targetMap.set(key, entry);
    }
    return entry;
}
function calculateChecksum(entry) {
    var checksum = entry.state;
    if (entry.deps) {
        entry.deps.forEach(function (depEntry) {
            checksum += depEntry.state;
        });
    }
    return checksum;
}
function dispatchDeep(entry) {
    if (entry.observed) {
        emitter.dispatch(entry);
    }
    if (entry.contexts) {
        entry.contexts.forEach(dispatchDeep);
    }
}
var contextStack = new Set();
function get(target, key, getter) {
    var entry = getEntry(target, key);
    if (contextStack.size && contextStack.has(entry)) {
        contextStack.clear();
        throw Error("Circular get invocation of the '" + key + "' property in '" + target.toString() + "'");
    }
    contextStack.forEach(function (context) {
        context.deps = context.deps || new Set();
        context.deps.add(entry);
        if (context.observed) {
            entry.contexts = entry.contexts || new Set();
            entry.contexts.add(context);
        }
    });
    contextStack.add(entry);
    if (entry.checksum && entry.checksum === calculateChecksum(entry)) {
        contextStack.delete(entry);
        return entry.value;
    }
    if (entry.deps && entry.deps.size) {
        entry.deps.forEach(function (depEntry) {
            if (depEntry.contexts)
                depEntry.contexts.delete(entry);
        });
        entry.deps = undefined;
    }
    try {
        var nextValue = getter(target, entry.value);
        if (nextValue !== entry.value) {
            entry.state += 1;
            entry.value = nextValue;
            dispatchDeep(entry);
        }
        entry.checksum = calculateChecksum(entry);
        contextStack.delete(entry);
    }
    catch (e) {
        contextStack.clear();
        throw e;
    }
    return entry.value;
}
function set(target, key, setter, value, force) {
    if (force === void 0) { force = false; }
    /*
    if (contextStack.size && !force) {
      contextStack.clear();
      throw Error(`Try to set '${key}' of '${target.toString()}' in get call`);
    }
    */
    var entry = getEntry(target, key);
    var newValue = setter(target, value, entry.value);
    if (newValue !== entry.value) {
        entry.checksum = 0;
        entry.state += 1;
        entry.value = newValue;
        dispatchDeep(entry);
    }
}
function invalidate(target, key, clearValue) {
    if (contextStack.size) {
        contextStack.clear();
        throw Error("Try to invalidate '" + key + "' in '" + target.toString() + "' get call");
    }
    var entry = getEntry(target, key);
    entry.checksum = 0;
    entry.state += 1;
    dispatchDeep(entry);
    if (clearValue) {
        entry.value = undefined;
    }
}
function observe(target, key, getter, observer) {
    var entry = getEntry(target, key);
    entry.observed = true;
    var lastValue;
    var unsubscribe = emitter.subscribe(entry, function () {
        var value = get(target, key, getter);
        if (value !== lastValue) {
            observer(target, value, lastValue);
            lastValue = value;
        }
    });
    return function unobserve() {
        unsubscribe();
        entry.observed = false;
        if (entry.deps && entry.deps.size) {
            entry.deps.forEach(function (depEntry) {
                depEntry.contexts.delete(entry);
            });
        }
    };
}
export { get, set, invalidate, observe };
//# sourceMappingURL=cache.js.map